'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _app = require('./app.html');

var _app2 = _interopRequireDefault(_app);

require('./app.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appComponent = {
  template: _app2.default
};

exports.default = appComponent;


// WEBPACK FOOTER //
// ./client/app/app.component.js